import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { CONSTANTS } from 'clink-components';

const { black, clinkLightPurple } = CONSTANTS.colors.general;
const { boqScratch } = CONSTANTS.s3;

const cardItemProps = {
  xs: 12,
  sm: 5,
  md: 5,
};
const creationCardPaperProps = {
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
  borderRadius: '8px',
};
const creationCardPaperBaseSx = {
  height: '100%',
  width: '100%',
  minWidth: 0,
  boxShadow: 'none',
  border: `1px solid ${clinkLightPurple}`,
  borderRadius: '8px',
  p: '4px',
};

/** Explicit widths so skeleton placeholders cannot collapse to content size. */
const creationCardItemSx = {
  boxSizing: 'border-box',
  flex: { xs: '1 1 100%', sm: '1 0 380px' },
  width: { xs: '100%', sm: 380 },
  minWidth: { xs: '100%', sm: 380 },
  maxWidth: { xs: '100%', sm: 480 },
  minHeight: 340,
  display: 'flex',
};

const CreationCardItem = ({ children, paperProps = {} }) => (
  <Box data-testid="boq-creation-card" sx={creationCardItemSx}>
    <Paper sx={{ ...creationCardPaperBaseSx, ...paperProps }}>
      <Box sx={{ p: 1, height: '100%', width: '100%' }}>{children}</Box>
    </Paper>
  </Box>
);

const creationCardActionButtonSx = {
  mt: 2,
  width: '100%',
  textTransform: 'none',
  fontSize: '13px',
  py: 1.25,
  borderRadius: '8px',
};
const doubleItemProps = cardItemProps;
const subItemProps = {
  xs: 12,
  sm: 6,
};
const titleProps = {
  fontSize: '14px',
  color: black,
  fontWeight: 'bold',
  textAlign: 'center',
};
const titleSx = { fontSize: '15px', pb: 0.5, ...titleProps };
const buttonBaseSx = {
  display: 'block',
  '&::after': {
    content: '""',
    display: 'block',
    width: '100%',
    height: '150px',
    marginRight: 1,
    backgroundImage: `url('${boqScratch}')`,
    backgroundSize: 'cover',
  },
};

const Container = ({ children }) => (
  <Box
    sx={{
      width: '100%',
      m: 'auto',
      p: 0,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'stretch',
      gap: { xs: 2, sm: 3 },
    }}
  >
    {children}
  </Box>
);

export {
  cardItemProps,
  creationCardPaperProps,
  creationCardPaperBaseSx,
  creationCardItemSx,
  CreationCardItem,
  creationCardActionButtonSx,
  doubleItemProps,
  subItemProps,
  titleProps,
  titleSx,
  buttonBaseSx,
  Container,
};
